import RootState from 'ducks/RootState';

export const getForgotPasswordForm = (state: RootState) => state.forgotPasswordForm;
